
import {
  defineComponent,
  ref,
  computed,
  reactive,
} from 'vue';
import { ElMessage, FormInstance } from 'element-plus';
import { getSysParamDetailApi, postSysParamSaveApi } from '@/api/sysparam';
import { PostSysParamSaveApiReq } from '@/api/sysparam/types';
import { DICTIONARY_STATUS_ENUM, DICTIONARY_STATUS_LIST } from '../constant';
import MonacoEditor from './monaco-editor.vue';
import RichEditor from './rich-editor.vue';

export default defineComponent({
  name: 'OperationDialog',
  computed: {},
  components: { MonacoEditor, RichEditor },
  emits: ['update:visible', 'handleOperateSuccess'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    paramId: {
      type: String,
      default: '',
    },
    // 'edit' | 'add' | 'preview'
    operationType: {
      type: String,
      default: 'add',
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });

    const initialFormData = {
      paramId: '',
      paramCode: '',
      paramName: '',
      description: '',
      dataType: DICTIONARY_STATUS_LIST[0]?.value || '',
      paramValue: '',
    };

    // 表单
    const formData = reactive<PostSysParamSaveApiReq>({ ...initialFormData });
    const formRef = ref<FormInstance>();

    const resetForm = () => {
      Object.assign(formData, initialFormData);
      formRef.value?.resetFields();
    };

    const handleOpen = async () => {
      if (props.paramId) {
        const { data } = await getSysParamDetailApi(props.paramId);
        Object.assign(formData, data);
      } else {
        resetForm();
      }
    };

    const handleClose = () => {
      selfVisible.value = false;
      resetForm();
    };

    const handleSave = async () => {
      await formRef.value?.validate();
      await postSysParamSaveApi({ ...formData });
      ElMessage.success('操作成功！');
      handleClose();
      emit('handleOperateSuccess');
    };

    return {
      formRef,
      formData,
      selfVisible,
      rules: {
        paramCode: [
          { required: true, message: '请输入参数编码', trigger: 'blur' },
          { max: 100, message: '长度100字符内', trigger: 'blur' },
        ],
        paramName: [
          { required: true, message: '请输入参数名称', trigger: 'blur' },
          { max: 100, message: '长度100字符内', trigger: 'blur' },
        ],
        dataType: [
          { required: true, message: '请选择参数类型', trigger: 'blur' },
          { max: 200, message: '长度100字符内', trigger: 'blur' },
        ],
        paramValue: [
          {
            validator: (rules: any, value: string, callback: (err?: string) => void) => {
              if (value !== '') {
                if (formData.dataType === DICTIONARY_STATUS_ENUM.NUMBER) {
                  const val = Number(value);
                  if (Number.isNaN(val)) {
                    callback('参数值必须为有效的数字');
                    return;
                  }
                } else if (formData.dataType === DICTIONARY_STATUS_ENUM.BOOLEAN) {
                  if (value !== 'true' && value !== 'false') {
                    callback('参数值必须为有效的布尔值');
                    return;
                  }
                } else if (formData.dataType === DICTIONARY_STATUS_ENUM.JSON) {
                  try {
                    JSON.parse(value);
                  } catch {
                    callback('参数值必须为有效的JSON');
                    return;
                  }
                }
              }
              callback();
            },
          },
        ],
      },
      handleClose,
      handleOpen,
      handleSave,
      DICTIONARY_STATUS_LIST,
      DICTIONARY_STATUS_ENUM,
    };
  },
});
